export default [
  {
    title: '月份',
    key: 'month'
  },
  {
    title: '策划人员',
    key: 'designerName'
  },
  {
    title: 'P级',
    key: 'level'
  },
  {
    title: '合格KPI',
    key: 'oneLevelNum'
  },
  {
    title: '优秀KPI',
    key: 'twoLevelNum'
  },
  {
    title: '卓越KPI',
    key: 'threeLevelNum'
  },
  {
    title: '更新人',
    key: 'updateName'
  },
  {
    title: '更新时间',
    key: 'updateTime'
  },
  {
    title: '操作',
    key: 'control'
  }
]
